import McDialog from './McDialog.vue'

McDialog.install = function(Vue){
    Vue.component(McDialog.name, McDialog);
}

export default McDialog;